import { render, staticRenderFns } from "./OverlayDialog.vue?vue&type=template&id=5363c513&scoped=true"
import script from "./OverlayDialog.vue?vue&type=script&lang=ts"
export * from "./OverlayDialog.vue?vue&type=script&lang=ts"
import style0 from "./OverlayDialog.vue?vue&type=style&index=0&id=5363c513&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5363c513",
  null
  
)

export default component.exports